
import AnimationInitializer from '../animation/Initializer'

class Pagination {
    constructor(el) {
        this.el = el
        this.section = this.el.dataset.section

        this.totalPages = parseInt(this.el.dataset.totalPages)
        this.currentPage = 1

        this.grid = document.querySelector(`#shopify-section-${this.section} .pagination-grid`)

        this.bindLoadMore()
    }


    bindLoadMore() {
        if (!this.button) {
            this.button = this.el.querySelector('.load-more')
        }

        if (!this.button.hasEventListener) {
            this.button.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()

                this.loadData(event)
            })

            this.button.hasEventListener = true
        }
    }

    loadData(event) {
        this.button.setAttribute('disabled', true)
        const link = this.button && this.button.href
        const url = `${link}&section_id=${this.section}`

        this.button.textContent = 'Loading...'

        /** --- Load from cache --- */

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    const error = new Error(response.status)

                    throw error
                }

                return response.text()
            })
            .then((text) => {
                const html = text

                this.renderGridWithPagination(html)
            })
            .catch((error) => {
                throw error
            })
    }

    renderGridWithPagination(html) {
        this.currentPage += 1
        const dom = new DOMParser().parseFromString(html, 'text/html')
        const fragment = document.createDocumentFragment()
    
        const items = dom.querySelectorAll('.article-item')
        const btn = dom.querySelector('.load-more')
        fragment.append(...items)
        this.grid.appendChild(fragment)
    
        if (btn) {
            this.button.href = btn.href
        }
    
        const pagination = dom.querySelector('.pagination-grid')
    
        if (!pagination || !pagination.innerHTML) {
            this.button.textContent = ''
            this.el.remove()
            return
        }
    
        this.innerHTML += pagination.innerHTML
    
        if (this.currentPage >= this.totalPages) {
            this.button.classList.add('hidden')
            this.button.textContent = ''  // Clear button text when no more items
        } else {
            this.button.textContent = 'Load more'
            this.button.removeAttribute('disabled')
        }
    }
    
}

// IIFE to invoke component on mount
(function init() {
    const paginationElement = document.querySelector('[data-pagination]')

    const pagination = new Pagination(paginationElement)

    self.Decimal.components.Pagination = { ...pagination, async: true }
})()
